/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {SyncActiveInstrumentLinksRequest} from '@cash-web/protos/squareup/cash/lynx/api/v1_0/internal/SyncActiveInstrumentLinks.pb'
import {SyncActiveInstrumentLinksResponse} from '@cash-web/protos/squareup/cash/lynx/api/v1_0/internal/SyncActiveInstrumentLinks.pb'


export const syncActiveInstrumentLinks = (request: SyncActiveInstrumentLinksRequest, options?: CashRequestOptions) => post<SyncActiveInstrumentLinksRequest, SyncActiveInstrumentLinksResponse>("/2.0/cash/sync-active-instrument-links", request, {...options, rejectOnError: true })